module.exports = __webpack_public_path__ + "static/media/Madlibs-Project.2c24d968.png";